import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

const InputWithAutoComplete = ({value,options,setValue}:any) => {
  const handleChange = (event:any,value:any) => {
    setValue(value);
  };
  return (
    <Autocomplete
      disablePortal
      id="combo-box-demo"
      options={options}
      freeSolo
      sx={{ minWidth:175}}
      // ref={ref}
      // onChange={handleChange}
      onInputChange={handleChange}
      // onChange={(event, value) => console.log(value)}
      value={value}
      renderInput={(params) => <TextField {...params} label="Source" />}
    />
  );
}

export default InputWithAutoComplete;
